import { Box, Stack, Text } from '@chakra-ui/react'
import { faMedal } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

import {
  LEADERBOARD_KEY_TO_PANEL_INFO,
  LEADERBOARD_TIME_FRAME_TO_LABEL,
  type LeaderboardHighlight,
} from '@/client/services/leaderboard'

export default function LeaderboardHighlightDisplay({
  highlight,
}: {
  highlight: LeaderboardHighlight | null
}): React.ReactElement | null {
  if (highlight == null) {
    return null
  }
  const { rank, percentile } = highlight
  if (rank == null && percentile == null) {
    return null
  }
  const { title } = LEADERBOARD_KEY_TO_PANEL_INFO[highlight.key]
  return (
    <Stack direction="row" spacing={2} align="center" textDecoration="none">
      <Box w="36px" fontSize="24px">
        <FontAwesomeIcon icon={faMedal} color={chakraTokenToVar('yellow.solid')} fontSize="24px" />
      </Box>
      <Box>
        <Text fontSize="20px" fontWeight="bold">
          {rank == null ? `Top ${percentile}%` : `#${rank}`} {title}
        </Text>
        <Text fontSize="14px" color="fg.muted">
          {LEADERBOARD_TIME_FRAME_TO_LABEL[highlight.timeFrame]}
        </Text>
      </Box>
    </Stack>
  )
}
